import { TranslationKey } from './../../../../types/translation/TranslationKey';

import dayjs from 'dayjs';
import { EntityTimeFrame } from '../common/filter.util';
import { t } from '../../../../types/translation/Translator';
import { MetricInterval } from '../../../../types/metrics/metricFilter';

export namespace StaticTimeFilterType {
  export const MAX = 'MAX';
  export const YEAR = 'YEAR';
  export const QUARTER = 'QUARTER';
  export const MONTH = 'MONTH';
  export const CURRENT_MONTH = 'CURRENT_MONTH';
  export const WEEK = 'WEEK';

  export function keys() {
    return [MAX, CURRENT_MONTH, YEAR, QUARTER, MONTH, WEEK];
  }

  export function toLocalizedString(item: string): string {
    switch (item) {
      case MAX:
        return t(TranslationKey.max).singular.label;
      case YEAR:
        return t(TranslationKey.twelveMonths).singular.label;
      case QUARTER:
        return t(TranslationKey.threeMonths).singular.label;
      case MONTH:
        return t(TranslationKey.thirtyDays).singular.label;
      case CURRENT_MONTH:
        return t(TranslationKey.currentMonth).singular.label;
      case WEEK:
        return t(TranslationKey.sevenDays).singular.label;
      default:
        return '';
    }
  }

  export function getTimeFrame(item: string): EntityTimeFrame {
    switch (item) {
      case MAX:
        return {
          start: dayjs('01/01/2022').toDate(),
          end: dayjs().endOf('day').toDate(),
          interval: MetricInterval.year,
        };
      case YEAR:
        return {
          start: dayjs().subtract(12, 'months').startOf('month').toDate(),
          end: dayjs().endOf('day').toDate(),
          interval: MetricInterval.month,
        };
      case QUARTER:
        return {
          start: dayjs().subtract(3, 'months').startOf('month').toDate(),
          end: dayjs().endOf('day').toDate(),
          interval: MetricInterval.month,
        };
      case MONTH:
        return {
          start: dayjs().subtract(30, 'days').startOf('day').toDate(),
          end: dayjs().endOf('day').toDate(),
          interval: MetricInterval.day,
        };
      case WEEK:
        return {
          start: dayjs().subtract(7, 'days').startOf('day').toDate(),
          end: dayjs().endOf('day').toDate(),
          interval: MetricInterval.day,
        };
      case CURRENT_MONTH:
        return {
          start: dayjs().startOf('month').subtract(1, 'day').endOf('day').toDate(),
          end: dayjs().endOf('day').toDate(),
          interval: MetricInterval.day,
        };
    }
    return { start: dayjs().toDate(), end: dayjs().toDate(), interval: MetricInterval.day };
  }
}
